import { render, staticRenderFns } from "./FinalizerDetail.vue?vue&type=template&id=049c4a7c&scoped=true"
import script from "./FinalizerDetail.vue?vue&type=script&lang=js"
export * from "./FinalizerDetail.vue?vue&type=script&lang=js"
import style0 from "./FinalizerDetail.vue?vue&type=style&index=0&id=049c4a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c4a7c",
  null
  
)

export default component.exports